'use strict';

// this directive takes the attribute value of toggle-panel as the selector to toggle
module.exports = /*@ngInject*/
function() {
    return {
        scope: {
            panelSelector: '@togglePanel'
        },
        link: function(scope, element, attrs) {
            element.bind('touchstart click', function(e) {

                // make sure currency-panel & account panel are not open at the same time
                if (scope.panelSelector === 'account-panel') {
                    jQuery('.currency-panel').slideUp();
                } else if (scope.panelSelector === 'currency-panel') {
                    jQuery('.account-panel').slideUp();
                }

                jQuery('.' + scope.panelSelector).slideToggle();

                e.preventDefault();
                e.stopPropagation();
            });
        }
    };
};
